<ft-modal-editor-wrapper [canSave]="!disabled">
    <ng-template #triggerTmpl>
        <ng-content />
    </ng-template>
    <div class="ft2-input -large v-center h-between">
        <label>{{label}}</label>
        <!-- Master's markup (legacy MatSlideToggle there, MDC here). a5dde2ef0e temporarily
             swapped in the raw v1 `.ft-switch` DOM while the MDC pill skin didn't exist;
             _mat-toggle.scss has since been rebuilt for MDC (geometry/colors/label/animation),
             so the Material toggle renders the same 70x30 green pill again. -->
        <mat-slide-toggle [name]="name" [(ngModel)]="value" [required]="required" #control="ngModel" [disabled]="disabled" />
    </div>
</ft-modal-editor-wrapper>
